module.exports = __webpack_public_path__ + "img/ico_upload.b09add0a.svg";